import { LazyAction, LazyModule } from 'owa-bundling';
import { SaveFocusInboxOptionStitchName, SaveFocusedInboxOptionStitch } from 'owa-focused-option';
import { subscribe } from 'satcheljs/lib/legacy/stitch';

export { default as initializeFocusedInboxConfig } from './actions/initializeFocusedInboxConfig';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FocusedInboxConfigActions", webpackPrefetch: true */ './lazyIndex')
);

export let lazySetFocusedInboxOnOff = new LazyAction(lazyModule, m => m.setFocusedInboxOnOff);

// Initialize stitch to listen to action in Options that toggles Focused Inbox
export function subscribeSaveFocusInboxOptionStitch() {
    // Type safety without pulling in a string reference and all the code that goes with it
    const stitchName: SaveFocusInboxOptionStitchName = 'saveFocusInboxOptionStitchName';
    subscribe<SaveFocusedInboxOptionStitch>(stitchName, (isFocusedInboxEnabled: boolean) =>
        lazySetFocusedInboxOnOff.importAndExecute(
            isFocusedInboxEnabled,
            true /* skipServiceRequest */
        )
    );
}
